export default {"src":"/_next/static/media/shopping_bag_icon.478918f4.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};